module.exports = __webpack_public_path__ + "static/how-to-teach-quantum-physics-to-your-dog-d2988709f5021babc43b99060b0fad65.jpg";